import React from 'react'
import Loader from 'react-loader-spinner'
import '../styles/components/LoadingCloset.css'

const LoadingCloset = () => {
  return (
    <div className='loading-closet'>
      <Loader
        type='TailSpin'
        color='var(--primary)'
        height={50}
        width={50}
      />
    </div>
  )
}

export default LoadingCloset



// WEBPACK FOOTER //
// ./src/components/LoadingCloset.js